import { Observable } from 'rxjs';
import { EmptyResponse, SerializableObject } from '../../core';

/**
 * The definition for the generic recent objects interface.
 */
export interface IRecentObjectsService<T extends SerializableObject> {
  /**
   * Returns the list of recent objects.
   */
  getRecentObjects(): Observable<T[]>;

  /**
   * Adds the object as the first one within the list of recent objects.
   * @param object The object to add at the top of the list of recent objects.
   */
  addToRecentObjects(object: T): Observable<EmptyResponse>;

  /**
   * Removes the object from the list of recent objects.
   * @param object The object to remove from the list of recent objects.
   */
  removeFromRecentObjects(object: T): Observable<EmptyResponse>;

  /**
   * Clears the list of recent objects.
   */
  clearRecentObjects(): Observable<EmptyResponse>;
}
